<template>
  <el-dialog
    title="Gerar Proposta" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="50%" v-loading="loading"
  >
    <div style="display: flex; flex-direction: column; gap: 10px; padding-bottom: 30px; border-bottom: 1px solid #dadada" v-if="imovel">
      <div>
        <span><i class="el-icon-s-home" style="color: #3a7297; font-size: medium; margin-right: 5px;"></i><strong>Imóvel: </strong>{{ `${imovel.idNaImobiliaria} - ${formatarLinha1EnderecoVisita(imovel)} / ${formatarLinha2EnderecoVisita(imovel)}` }}</span>
      </div>
      <div>
        <span><i class="el-icon-money" style="color: #279910; font-size: medium; margin-right: 5px;"></i><strong>Valor do Imóvel: </strong>{{ formatarValor(imovel.valor) }}</span> <span style="margin-left: 20px;"><i :class="(imovel.operacao === 'VENDA' ? 'el-icon-price' : 'el-icon-s-management') + ' blue-icon'"></i><span style="font-weight: bold;">Operação:</span>{{ ` ${getLabelOperacao(imovel.operacao)}`}}</span>
      </div>
      <div>
        <span><i class="el-icon-user" style="color: #3a7297; font-size: medium; margin-right: 5px;"></i><strong>Cliente: </strong>{{ atendimento.cliente.nome }}</span>
      </div>
    </div>

    <el-form :model="proposta">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Data da Proposta">
            <el-date-picker
              auto-complete="off"
              v-model="proposta.data"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
              size="small"
              disabled
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Valor da Proposta">
            <div class="el-input el-input--small">
              <money
                v-model="proposta.valor"
                v-bind="money"
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Percepção do usuário">
            <el-slider
              v-model="proposta.percepcaoUsuario"
              :step="10"
              show-stops
              :format-tooltip="formatPercepcao"
              style="margin-top: 15px;"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Validade da Proposta">
            <el-select
              v-model="proposta.diasValidade"
              size="small"
              style="width: 100%;"
            >
              <el-option :value="7" label="07 dias"></el-option>
              <el-option :value="15" label="15 dias"></el-option>
              <el-option :value="30" label="30 dias"></el-option>
              <el-option :value="60" label="60 dias"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item>
            <template slot="label">
              Tipo de autenticação da proposta
              <i style="font-size: 11px; color: crimson;">{{ labelAvisoAuthMode }}</i>
            </template>
            <el-select 
              v-model="proposta.modoAutenticacao"
              size="small"
              style="width: 100%;"
            >
              <el-option
                v-for="authMode in authModes"
                :key="authMode.id"
                :label="authMode.label"
                :value="authMode.data"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Condições de Pagamento">
            <el-input v-model="proposta.condicoesDePagamento" type="textarea" maxlength="200" show-word-limit rows="3"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gerarPropostaHandler" round size="small" class="btn-box-shadow" type="primary">
        Gerar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { mapActions } from 'vuex'
  import { Money } from "v-money";

  import { AUTH_MODE_ZAP_SIGN, OPERACAO_IMOVEL } from '../../../util/constantes';
  import Util from "../../../util/funcoes.js"

  export default {
    props: {
      visibility: Boolean,
      imovel: Object,
      atendimento: Object
    },

    components: { 
      Money
    },

    data() {
      return {
        proposta: {
          data: Util.hoje(),
          diasValidade: 7,
          modoAutenticacao: 'ASSINATURA_TELA'
        },

        money: {
          decimal: ",",
          thousands: ".",
          precision: 2,
          prefix: "R$ ",
          masked: false
        },
      }
    },

    computed:{
      loading() {
        return this.$store.state.loading;
      },

      authModes() {
        return AUTH_MODE_ZAP_SIGN
      },
      operacaoImovel() {
        return OPERACAO_IMOVEL;
      },
      labelAvisoAuthMode() {
        switch (this.proposta.modoAutenticacao) {
          case 'CERTIFICADO_DIGITAL':
            return 'OBS: Tem um custo de R$ 0,50 por signatário';
          case 'CPF':
            return 'OBS: Tem um custo de R$ 1,00 por assinatura realizada com sucesso';
          case 'TOKEN_WHATSAPP':
            return 'OBS: Tem um custo de R$ 0,50 por cada envio automático do token.';
          case 'ASSINATURA_TELA_TOKEN_WHATSAPP':
            return 'OBS: Tem um custo de R$ 0,50 por cada envio automático do token.';
          case 'TOKEN_SMS':
            return 'OBS: Tem um custo de R$ 0,10 por cada envio automático do token.';
          case 'ASSINATURA_TELA_TOKEN_SMS':
            return 'OBS: Tem um custo de R$ 0,10 por cada envio automático do token.';
          default: 
            return '';
        }
      }
    },

    methods:{
      ...mapActions([
        'showLoading',
        'hideLoading'
      ]),
      ...mapActions('vendasAtendimentosStore', [
        'gerarProposta',
        'listarAtendimentos'
      ]),

      getPayloadGerarProposta() {
        return {
          ...this.atendimento,
          propostas:[{
            acao: 'ABERTURA',
            data: this.proposta.data,
            valor: this.proposta.valor,
            diasValidade: this.proposta.diasValidade,
            condicoesDePagamento: this.proposta.condicoesDePagamento,
            percepcaoUsuario: (this.proposta.percepcaoUsuario / 10) + this.imovel.avaliacao,
            modoAutenticacao: this.proposta.modoAutenticacao,
            cliente: this.atendimento.cliente,
            atendimento: this.atendimento,
            imovel: this.imovel
          }]
        }
      },

      gerarPropostaHandler() {
        const payload = this.getPayloadGerarProposta();

        this.showLoading();
        this.gerarProposta(payload)
        .then(resposta => {
          switch(resposta.status) {
            case 'SUCESSO':
              this.$message.success('Proposta gerada com sucesso!');
              this.fechar();
              break;
            default:
              this.$message.error('Ocorreu um erro ao comunicar-se com o servidor.')
          }
        }).catch(error => {
          this.$message.error('Ocorreu um erro ao comunicar-se com o servidor.');
          throw error;
        }).finally(() => {
          this.hideLoading();
        })
      },

      formatPercepcao(val) {
        return val / 10
      },

      formatarLinha1EnderecoVisita(imovel) {
        return imovel.endereco + ", " + imovel.numeroEndereco;
      },
      formatarLinha2EnderecoVisita(imovel) {
        return (imovel.condominio.nome !== undefined ? imovel.condominio.nome + " - " + imovel.bairro.nome + " - " + imovel.cidade.nome : imovel.bairro.nome + " - " + imovel.cidade.nome)
      },
      formatarValor(valor) {
        return Util.formatarValor(valor);
      },

      getLabelOperacao(value) {
        return Util.getLabel(OPERACAO_IMOVEL, value)
      },

      resetForm() {
        this.proposta = {
          data: Util.hoje(),
          diasValidade: 7,
          modoAutenticacao: 'ASSINATURA_TELA'
        }
      },

      fechar() {
        this.resetForm();
        this.$emit("close");
      },
    }
  } 
</script>